<template>
  <section id="service">
    <v-layout column wrap class="purple lighten-5" align-center>
      <v-flex xs12 sm4 class="my-3 pa-5">
        <div class="text-xs-center">
          <h2 class="headline">事業内容</h2>
          <span class="subheading purple--text">
            Services
          </span>
        </div>
      </v-flex>
      <v-flex xs12 class="mb-5">
        <v-container>
          <v-layout row wrap align-center>
            <v-flex xs12 md6>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="pink--text text--lighten-2"
                    >face</v-icon
                  >
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center">
                    騎手マネージメント
                  </div>
                </v-card-title>
                <v-card-text>
                  騎手等のスポーツ選手のマネージメントおよびプロモート。
                  騎手の騎乗スケジュールの管理、騎乗用ぐの整備・調整、雑務等のサポート業務
                  騎手や競走馬に関する資料の収集およびその展示館の企画・運営・管理。
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="pink--text text--lighten-2"
                    >supervisor_account</v-icon
                  >
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">芸能マネージメント</div>
                </v-card-title>
                <v-card-text>
                  芸能タレント、歌手、アナウンサー、ニュースキャスター司会者等のマネージメントおよびプロモート業務
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center class="my-3">
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="pink--text">book</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center">
                    グッズ・出版
                  </div>
                </v-card-title>
                <v-card-text>
                  出版物の企画、執筆、編集および出版
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="pink--text text--lighten-2"
                    >school</v-icon
                  >
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-xs-center">
                    スクール
                  </div>
                </v-card-title>
                <v-card-text>
                  カルチャースクールの企画・運営
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card class="elevation-0 transparent">
                <v-card-text class="text-xs-center">
                  <v-icon x-large class="pink--text text--lighten-2"
                    >local_dining</v-icon
                  >
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">レストラン・飲食店経営</div>
                </v-card-title>
                <v-card-text>
                  レストラン・飲食店経営
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
